import { gql } from "apollo-boost";

const TERMINATE_ACCOUNT = gql`
  mutation TerminateAccount($email: String!, $reason: String!) {
    terminateAccount(email: $email, reason: $reason) {
      status
      code
      message
    }
  }
`;

export default TERMINATE_ACCOUNT;
